'use client';
import React__default from 'react';
import PropTypes from 'prop-types';
import { TOGGLE_SIZES } from './Toggle.constants.js';
import { ToggleContainer, Checkbox, Indicator, Circle } from './Toggle.styles.js';
import LabelBody from '../../Label/LabelBody.js';
import ScreenReaderOnly from '../../ScreenReaderOnly/index.js';

var Toggle = function Toggle(_ref) {
  var onChange = _ref.onChange,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    label = _ref.label,
    _ref$hasLabel = _ref.hasLabel,
    hasLabel = _ref$hasLabel === void 0 ? true : _ref$hasLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? TOGGLE_SIZES.REGULAR : _ref$size,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    id = _ref.id,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var handleChange = function handleChange(e) {
    if (!disabled && (e.key === 'Enter' || e.type === 'click')) {
      onChange(e);
    }
  };
  var labelSize = size === TOGGLE_SIZES.SMALL ? 'medium' : TOGGLE_SIZES.REGULAR;
  return React__default.createElement(ToggleContainer, {
    $disabled: disabled,
    $checked: checked,
    "data-testid": testId
  }, React__default.createElement(Checkbox, {
    id: id,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    tabIndex: "-1"
  }), React__default.createElement(Indicator, {
    $checked: checked,
    $size: size,
    $disabled: disabled,
    $hasLabel: hasLabel,
    tabIndex: disabled ? '-1' : '0',
    onKeyDown: handleChange,
    onClick: handleChange
  }, React__default.createElement(Circle, {
    $checked: checked,
    $size: size
  })), hasLabel ? React__default.createElement(LabelBody, {
    size: labelSize,
    htmlFor: id
  }, label) : React__default.createElement(ScreenReaderOnly, {
    as: "label",
    htmlFor: id
  }, label));
};
Toggle.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  hasLabel: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(Object.values(TOGGLE_SIZES)),
  testId: PropTypes.string
};

export { Toggle };
//# sourceMappingURL=Toggle.js.map
